import { useToast } from '@chakra-ui/react';
import { manualRefreshTriggerById } from 'api/reports';
import { useMutation } from 'react-query';
import RefreshSvg from 'svg/Refresh';

type RefreshProps = {
  _id: string;
};

const RefreshHarvestSummary = ({ _id }: RefreshProps) => {
  const toast = useToast();
  const { mutate: refresh } = useMutation(manualRefreshTriggerById, {
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Success',
        description: 'Harvest Summary Refreshed',
        isClosable: true,
        duration: 5000,
      });
    },
  });
  return (
    <div onClick={() => refresh(_id)} title="Click to refresh">
      <RefreshSvg />
    </div>
  );
};

export default RefreshHarvestSummary;
